import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export type LoadingOverlayProps = {
  show: boolean;
  /** Minimum height for the wrapped area so the spinner has space */
  minHeight?: number;
  /** Optional message under the spinner (e.g., "Loading data…") */
  label?: string;
  /** How strong the glassy blur looks (pixels) */
  blurPx?: number;
  /** Background scrim color */
  scrim?: string;
  /** Spinner diameter in px (MUI default is 40) */
  spinnerSize?: number;
  children: React.ReactNode;
};

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  show,
  minHeight = 320,
  label,
  blurPx = 1,
  scrim = "rgba(255,255,255,0.5)",
  spinnerSize,
  children,
}) => (
  <Box position="relative" minHeight={minHeight}>
    {children}
    {show && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: scrim,
          backdropFilter: `blur(${blurPx}px)`,
          zIndex: 2,
        }}
      >
        <CircularProgress size={spinnerSize} />
        {label ? (
          <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>
            {label}
          </Typography>
        ) : null}
      </Box>
    )}
  </Box>
);

export default LoadingOverlay;
